'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { BoxPrimitive } from '#pplx/frontend/aether/primitives/BoxPrimitive/index.js';
import { IconPrimitive } from '#pplx/frontend/aether/primitives/IconPrimitive/index.js';
import { TextDocumentPreview } from '#pplx/frontend/apps/ask/shared-ui-components/TextDocumentPreview.js';
import { isTextDocumentAssetType } from '#pplx/frontend/apps/ask/shared-ui-components/TextDocumentPreviewShared.js';
import { LinkFavicon } from '#pplx/frontend/components/links/LinkFavicon.js';
import React, { useCallback, useState } from 'react';
/**
 * Renders a styled preview area for an asset card.
 * Shows the preview image when available, a text-document snippet for
 * text-based asset types, or a generic icon as a last resort.
 */
export const AssetCardPreview = React.memo(function AssetCardPreview({ assetType, filename, mimeType, previewImageUrl, displayName, icon, previewTextContent, faviconDomain, }) {
    const [imageError, setImageError] = useState(false);
    const handleImageError = useCallback(() => setImageError(true), []);
    if (previewImageUrl && !imageError) {
        return (_jsx("img", { src: previewImageUrl, alt: displayName, className: "size-full object-cover object-top", onError: handleImageError }));
    }
    if (isTextDocumentAssetType(assetType, filename, mimeType) && previewTextContent) {
        return _jsx(TextDocumentPreview, { previewTextContent: previewTextContent });
    }
    return (_jsx(BoxPrimitive, { display: "flex", align: "center", justify: "center", bg: "subtle", className: "size-full", children: faviconDomain ? (_jsx(LinkFavicon, { domain: faviconDomain, size: 40, hideBorder: true })) : (_jsx(IconPrimitive, { icon: icon, className: "text-secondary size-8 opacity-40" })) }));
});
//# sourceMappingURL=AssetCardPreview.js.map